import { createI18n } from "vue3-i18n";
import { messages_tr } from "./locales/tr.js";
import { messages_en } from "./locales/en.js";
export const messages = {
  en: messages_en,
  tr: messages_tr,
};

const i18n = createI18n({
  locale: "en",
  messages: messages,
  debug: false, // It should be false
});

export default i18n;
